import { render, staticRenderFns } from "./OtherUserPermittedFunctionEdit.vue?vue&type=template&id=73e40b6c&scoped=true&lang=pug"
import script from "./OtherUserPermittedFunctionEdit.vue?vue&type=script&lang=ts"
export * from "./OtherUserPermittedFunctionEdit.vue?vue&type=script&lang=ts"
import style0 from "./OtherUserPermittedFunctionEdit.vue?vue&type=style&index=0&id=73e40b6c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "73e40b6c",
  null
  
)

export default component.exports